<template>
  <section class="select-reports">
    <header>
      <div class="flow-btn"></div>
      <div class="title">
        <h1>{{ $t('reports.title') }}:</h1>
        <p>{{ $t('reports.subtitle') }}</p>
      </div>
      <!-- <router-link tag="button">Continue</router-link> -->
      <div class="flow-btn"><button @click="nextStep">{{ $t('buttons.createReports') }}</button></div>
    </header>
    <div class="toggle-buttons">
      <toggle-button v-model="checkedAllMedia" :label="$t('reports.allMedia')"></toggle-button>
      <toggle-button v-model="checkedLiveMedia" :label="$t('reports.liveMedia')"></toggle-button>
      <toggle-button v-model="checkedArchivedMedia" :label="$t('reports.archivedMedia')"></toggle-button>
      <toggle-button v-model="checkedIncompleteMedia" :label="$t('reports.incompleteMedia')"></toggle-button>
      <toggle-button v-model="checkedMediaByScreen" :label="$t('reports.mediaByScreen')"></toggle-button>
      <toggle-button v-model="checkedMediaByPriority" :label="$t('reports.mediaByPriority')"></toggle-button>
      <toggle-button v-model="checkedMediaByPartnerProgram" :label="$t('reports.mediaByPartnerProgram')"></toggle-button>
      <toggle-button v-model="checkedMediaByChannel" :label="$t('reports.mediaByChannel')"></toggle-button>
      <toggle-button v-model="checkedMediaById" :label="$t('reports.mediaByID')"></toggle-button>
      <toggle-button v-model="checkedAllChargers" :label="$t('reports.allChargers')"></toggle-button>
    </div>
  </section>
</template>

<script>
import ToggleButton from '@/components/ToggleButton.vue'

export default {
  name: 'select-reports',
  components: {
    ToggleButton
  },
  data() {
    return {
      checkedAllMedia: false,
      checkedLiveMedia: false,
      checkedArchivedMedia: false,
      checkedIncompleteMedia: false,
      checkedMediaByScreen: false,
      checkedMediaByPriority: false,
      checkedMediaByPartnerProgram: false,
      checkedMediaByChannel: false,
      checkedMediaById: false,
      checkedAllChargers: false
    }
  },
  methods: {
    nextStep() {
      this.$emit('to', 'done')
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-buttons {
  margin: 30px 0 0 -25px;
}
</style>
